var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 23,
    viewBox: "0 0 33 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H9.1345V22.5H0V0.5ZM23.8655 0.5H33V22.5H23.8655V0.5ZM19.7164 13.7515L22.9585 12.1304L21.3374 11.3199V9.69883L18.0953 11.3199L19.7164 8.07778H18.0953L16.4743 5.6462L14.8532 8.07778H13.2322L14.8532 11.3199L11.6111 9.69883V11.3199L9.99006 12.1304L13.2322 13.7515L12.4216 15.3725H15.6637V17.8041H17.2848V15.3725H20.5269L19.7164 13.7515Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCa);
export default __webpack_public_path__ + "static/media/ca.704c995030b0996332f8c89a1fc3ec24.svg";
export { ForwardRef as ReactComponent };